import EnumEntityField from './EnumEntityField'
export default {
  install(Vue) {
    Vue.component('EnumEntityField', EnumEntityField)
  },
}
